import { z } from 'zod'
import { dashboardPluginSizeSchema } from './dashboard-plugin-size.schema'

export const updateDashboardPluginSchema = z.object({
  size: dashboardPluginSizeSchema.optional(),
  config: z.record(z.string(), z.unknown()).optional(),
  enabled: z.boolean().optional(),
})
export type UpdateDashboardPluginDto = z.infer<typeof updateDashboardPluginSchema>
